import qs from 'qs';
import { useMemo } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

export const useQueryParams = <T>(): {
  queryParams: T;
  removeQueryParams: (queryParams: (keyof T)[]) => void;
  setQueryParams: (queryParams: T) => void;
  updateQueryParams: (queryParams: T) => void;
} => {
  const location = useLocation();

  const history = useHistory();

  const queryParams = useMemo<T>(
    () => (qs.parse(location.search, { ignoreQueryPrefix: true }) as unknown) as T,
    [location.search]
  );

  const updateQueryParams = (appliedQueryParams: T) => {
    history.push(
      {
        pathname: location.pathname,
        search: qs.stringify(
          {
            ...queryParams,
            ...appliedQueryParams
          },
          { addQueryPrefix: false }
        )
      },
      { replace: true }
    );
  };

  const setQueryParams = (appliedQueryParams: T) => {
    history.push(
      {
        pathname: location.pathname,
        search: qs.stringify(
          {
            ...appliedQueryParams
          },
          { addQueryPrefix: false }
        )
      },
      { replace: true }
    );
  };

  const removeQueryParams = (keys: (keyof T)[]) => {
    const newQueryParams = { ...queryParams };

    keys.forEach((key) => {
      delete newQueryParams[key];
    });

    history.push(
      {
        pathname: location.pathname,
        search: qs.stringify(newQueryParams, { addQueryPrefix: false })
      },
      { replace: true }
    );
  };

  return {
    queryParams,
    removeQueryParams,
    setQueryParams,
    updateQueryParams
  };
};
